import * as types from 'legacy/src/constants/types';

export function setSecureAssignmentIds(secureAssignmentIds) {
  return (dispatch) => {
    dispatch({
      type: types.SET_SECURE_ASSIGNMENT_IDS,
      secureAssignmentIds,
    });
  };
}
